import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 3.6a.9.9 0 0 1 .9.9v12.766l4.751-4.99a.9.9 0 1 1 1.298 1.248l-6.3 6.6a.9.9 0 0 1-1.298 0l-6.3-6.6a.9.9 0 0 1 1.298-1.248l4.751 4.99V4.5a.9.9 0 0 1 .9-.9"
    }, null, -1)
  ])))
}
export default { render: render }